import { useState } from "react";
import { AdminLayout } from "../Admin/AdminLayout";
import { ReferrerDashboard } from "./ReferrerDashboard";
import { ReferrerLeads } from "./ReferrerLeads";
import { ReferrerSettings } from "./ReferrerSettings";

export function Referrer({ idToken, username, onSignOut }) {
    const [activeSection, setActiveSection] = useState("dashboard");

    const renderSection = () => {
        switch (activeSection) {
            case 'dashboard':
                return <ReferrerDashboard idToken={idToken} />;
            case 'leads':
                return <ReferrerLeads idToken={idToken} />;
            case 'settings':
                return <ReferrerSettings idToken={idToken} username={username} />;
            default:
                return <ReferrerDashboard idToken={idToken} />;
        }
    };

    return (
        <AdminLayout
            activeSection={activeSection}
            onSectionChange={setActiveSection}
            isAdmin={false}
            isReferrer={true}
            username={username}
            onSignOut={onSignOut}
        >
            {renderSection()}
        </AdminLayout>
    );
}
